import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    href: String,
    target: { type: String, default: "_self" },
  };

  connect() {
    this.element.style.cursor = "pointer";
  }

  navigate(e) {
    if (e.target.closest("a, button, form")) return;
    window.open(this.hrefValue, this.targetValue);
  }
}
